import React from 'react';
import { Heart } from 'lucide-react';

/**
 * Persistent "Donate" CTA for guest-facing gallery pages (/gallery/live, /gallery/{id}/upload).
 * Gallery pages intentionally skip the main Layout for a clean mobile-first QR-scan experience,
 * so this lightweight pinned button restores access to the donate flow.
 */
const GalleryDonateTab = () => {
  // Open in a new tab so guests don't lose their photo-upload progress
  const href = '/donate';
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="gallery-donate-tab"
      aria-label="Donate to Novena Humanitarian Foundation"
      className="fixed top-4 right-4 z-40 inline-flex items-center gap-1.5 bg-[#BA1826] hover:bg-[#8B0F1C] text-white px-3.5 py-2 rounded-full shadow-md hover:shadow-lg transition-all text-xs font-semibold uppercase tracking-wider"
    >
      <Heart className="w-3.5 h-3.5" fill="currentColor" />
      Donate
    </a>
  );
};

export default GalleryDonateTab;
